import { object, string } from 'yup';

import { PAYMENT_COUPON_FLOW_OPTIONS } from '../../../constants/paymentCouponFlowOptions';

export const FIELDS_NAME = {
  FLOW: 'flow',
  AMOUNT: 'amount',
  CPF: 'cpf',
};

export const initialValues = {
  [FIELDS_NAME.FLOW]: PAYMENT_COUPON_FLOW_OPTIONS[0].value,
  [FIELDS_NAME.AMOUNT]: '',
  [FIELDS_NAME.CPF]: '',
};

export const isSelectedPix = (flow) => flow === 'pix';

export const validationSchema = (t) =>
  object().shape({
    [FIELDS_NAME.FLOW]: string().required(t('validations.required')),
    [FIELDS_NAME.AMOUNT]: string().required(t('validations.required')),
    [FIELDS_NAME.CPF]: string().when(FIELDS_NAME.FLOW, {
      is: (currentVal) => isSelectedPix(currentVal),
      then: (schema) =>
        schema
          .min(11, t('validations.cpf'))
          .required(t('validations.required')),
      otherwise: (schema) => schema.notRequired(),
    }),
  });
